import PropTypes from 'prop-types';

import { Collapsible } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import CollapsibleIcon from './icons/CollapsibleIcon';

import './HowToBookSection.scss';

export const HowToBookSection = ({
  stepNumber,
  title,
  renderContent,
  isCollapsed = true
}) => {
  return (
    <div className="how-to-book-section-redesign">
      <Collapsible
        bodyClassName="how-to-book-section-redesign__collapsible-body"
        hasIcon
        isCollapsed={isCollapsed}
        iconClosed={<CollapsibleIcon collapsed />}
        iconOpened={<CollapsibleIcon collapsed={false} />}
        renderHeader={() => (
          <div className="how-to-book-section-redesign__title">
            <div className="how-to-book-section-redesign__title__step">
              {trans('listings.how-to-book.step', { stepNumber })}
            </div>
            <div>{trans(title)}</div>
          </div>
        )}
        renderBody={() => (
          <span className="how-to-book-section-redesign__body">
            {renderContent()}
          </span>
        )}
      />
    </div>
  );
};

HowToBookSection.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  renderContent: PropTypes.func.isRequired,
  isCollapsed: PropTypes.bool
};

export default {
  HowToBookCollapsableSection: HowToBookSection
};
